import {
    LEFTMENU_METHOD,
    NHANVIENS_METHOD,
    NPP_ROLE,
    ROLE_MENU_METHOD,
    INIT_ROLE_MENU,
    STATUS_METHOD,
    TINHTHANHS_METHOD,
    QUANHUYENS_METHOD,
    PHUONGXAS_METHOD,
    MAIN_METHOD
} from '@app/const/AppSetting';
import {getControllerName} from '@app/utils/helpers';
import axiosClient from './axios';
import {alertService} from "@app/services/alertService";
import {Redirect, Route} from "react-router-dom";
import { getAll as trangthaiSlice_getAll } from '@store/reducers/trangthaiSlice';
const  MY_METHOD = MAIN_METHOD;

export const getAllPhanquyen= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listphanquyen`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllTiepdien= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listtiepdien`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const showMenuRole = async () => {
    const v = await axiosClient.get(MY_METHOD+'menu_role/');
   // console.log(v);
    if(v && v.data && v.data.data)
        return v.data.data;
    else
        return null;
};
export const showMenuappRole = async () => {
    const v = await axiosClient.get(MY_METHOD+'menuapp_role/');
    // console.log(v);
    if(v && v.data && v.data.data)
        return v.data.data;
    else
        return null;
};

export const showLeftMenu = async () => {
    const v = await axiosClient.get(MY_METHOD+'menu_user/');
    console.log('showLeftMenu');
    if(v && v.data && v.data.data)
        return v.data.data;
    else
        return null;
};



export const getAllTrangthai= async (dispatch) => {
    try {
      //  console.log('🔍 getAllTrangthai START - Token:', localStorage.getItem('token') ? 'EXISTS' : 'NULL');

        const res = await axiosClient.get(`${MY_METHOD}listtrangthai`);
      //  console.log('getAllTrangthai');

      //  console.log('🔍 getAllTrangthai AFTER API CALL - Token:', localStorage.getItem('token') ? 'EXISTS' : 'NULL');
      //  console.log('🔍 getAllTrangthai API Response Status:', res.status);

        // Debug the response data
     //   console.log('🔍 getAllTrangthai Response data type:', typeof res.data);
     //   console.log('🔍 getAllTrangthai Response data preview:', res.data ? JSON.stringify(res.data).substring(0, 200) : 'null');

      //  console.log('🔍 getAllTrangthai BEFORE DISPATCH - Token:', localStorage.getItem('token') ? 'EXISTS' : 'NULL');
        dispatch(trangthaiSlice_getAll(res.data.data));
        //console.log('🔍 getAllTrangthai AFTER DISPATCH - Token:', localStorage.getItem('token') ? 'EXISTS' : 'NULL');

        return res.data.data;
    } catch (err) {
        console.error('💥 getAllTrangthai ERROR:', err);
        console.log('🔍 getAllTrangthai ERROR - Token:', localStorage.getItem('token') ? 'EXISTS' : 'NULL');
        console.log('💥 Error status:', err.response?.status);
        console.log('💥 Error message:', err.response?.data);
    }
};
export const getAllCapcoquan= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listcapcoquan`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}



export const getAllLoaitailieu
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listloaitailieu`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllAnchay
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listanchay`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllMoiquanhe
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listmoiquanhe`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllLoaithongbao
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listloaithongbao`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}


export const getAllGioitinh
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listgioitinh`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllCountries
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listcountries`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllCity
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listcity`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllDistrict
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listdistrict`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllWards
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listwards`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}


export const getAutocompletedaohuu
= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}timkiemdaohuu`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllNhomsukien
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listnhomsukien`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllLoaisukien
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listloaisukien`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllLoainhadan
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listloainhadan`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllPhanloaisukien
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listphanloaisukien`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}




export const getAllNhadan= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listnhadan`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllLoaiphansucap1= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listloaiphansucap1`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllLoaiphansucap2= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listloaiphansucap2`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllnhomphansu= async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listnhomphansu`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const resetPassword = async (param) => {
    return axiosClient.put(`changepassword`,param);
}

export const getAllCoquan= async () => {
    try {
        const res = await axiosClient.get(`${MY_METHOD}listcoquan`);
        //console.log('getAllCoquan');
        //dispatch(trangthaiSlice_getAll(res.data.data));  
        return res.data.data;      
    } catch (err) {
    }
};

export const getAllLoaibieumautailieu
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listloaibieumautailieu`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllLoaithanhgiao
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listloaithanhgiao`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getAllThoi
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listthoi`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllHinhthuc
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listhinhthuc`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}


export const getAllPhansu
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listphansu`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}
export const getAllBieumautailieu
    = async (paramFilter) => {
    const v = axiosClient
        .post(
            `${MY_METHOD}listbieumautailieu`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

export const getNPPRole = async () => {
    const v = await axiosClient.get(NPP_ROLE);
    return v.data.data;
};

export const getTrangthai = async () => {
    const v = await axiosClient.get(STATUS_METHOD);
    return v.data.data;
};

export const getTinhthanh = async () => {
    const v = await axiosClient.get(TINHTHANHS_METHOD);
    /*console.log(
                'getAll tinhthanh= ',
                JSON.stringify(v.data.data, null, 2)
            );*/
    return v.data.data;
};

export const getQuanhuyen = async (id) => {
    if(id){
        const v = await axiosClient.get(`${QUANHUYENS_METHOD}?tinhthanhid=${id}`);
        return v.data.data;
    }
    else{
        const v = await axiosClient.get(`${QUANHUYENS_METHOD}`);
        return v.data.data;
    }
};

export const getPhuongxa = async (id) => {
    if(id)
    {
        const v = await axiosClient.get(`${PHUONGXAS_METHOD}?quanhuyenid=${id}`);
        return v.data.data;
    }
    else
    {
        const v = await axiosClient.get(`${PHUONGXAS_METHOD}`);
        return v.data.data;
    }
};

export const getSolanin = async (prefix, id) => {
    const v = await axiosClient.get(`solanin?loai=${prefix}&nghiepVuId=${id}`);
    return v.data.data;
};

export const postSolanin = async (prefix, id) => {
    const v = await axiosClient.post(`solanin?loai=${prefix}&nghiepVuId=${id}`);
    return v.data.data;
}

// eslint-disable-next-line camelcase,consistent-return
export const getRoleMENU = async (pathName) => {

    const controller = getControllerName(pathName);
    const res = await axiosClient .get(MY_METHOD + 'rolemenu/' + controller);
    //console.log('getRoleMENU');
    //console.log(res);
    if( res && res.data.status ==="1")
        return res.data.data;
    return INIT_ROLE_MENU
};

export const getRoleMENUApp = async (pathName) => {

    const controller = getControllerName(pathName);
    const res = await axiosClient .get(MY_METHOD + 'menuapp_role/' + controller);
    //console.log('getRoleMENU');
    //console.log(res);
    if( res && res.data.status ==="1")
        return res.data.data;
    return INIT_ROLE_MENU
};

export const checkRole = async (obj) => {
    const res = 
        getRoleMENU(obj.pathname)
        .then((role) => {
            if (obj.isAddMode && role.quyentaomoi !== 1) {
                obj.history.push(`/${obj.currController}`);
            }
            if (
                obj.pathname.indexOf(`edit`) > 0 &&
                !obj.isAddMode &&
                role.quyenchinhsua !== 1
            ) {
                obj.history.push(`/${obj.currController}`);
            }
            if (         
                role.quyenhienthi !== 1
            ) {
                obj.history.push(`/${obj.currController}`);
            }

            return role;
        })
        .catch((error) => {
            obj.history.push(`/${obj.currController}`);
        });
    return res;
};



export  const createObj =  async function (data, history,service, type,controller) {

    const result = await service.create(data);
    if (result.status) {
        alertService.success('Tạo mới thành công', {
            keepAfterRouteChange: true
        });
        //isAddMode = false;
        let id =result.data.id;
        //Nếu = 1 thì redirect tại trang edit, khác thì redirect đi đâu thì đi
        if(type === 1) {
            //let url = '/'+controller+'/edit/'+id;
            //console.log('url: '+url);
            //return <Redirect to='/SanPham/edit/1073' />;
            history.push('/'+controller+'/edit/'+id);
        }
        else {
            history.push('.');
        }
    } else {
        alertService.error(result.msg);
    }
}
export  const updateObj =  async function (idX,data, history,service, type, controller, msg) {
    const result = await service.update(idX, data);
    if (result.status) {
        alertService.success(msg, {
            keepAfterRouteChange: true
        });
        //Nếu = 1 thì redirect tại trang edit, khác thì redirect đi đâu thì đi
        if(type === 1) {
            history.push('/'+controller+'/edit/'+idX);
        }
        else {
            history.push('..');
        }

    } else {
        alertService.error(result.msg);
    }
}
